/** 0.44 points per level; every unlocked skill consumes one whole point. */
export function usesSkillPointSystem(serverId:number|undefined):boolean { return serverId===1||serverId===2; }
export function getAvailableSkillPoints(level: number, unlockedSkills: number): number {
  return Math.max(0, level * 44 - unlockedSkills * 100) / 100;
}
